import { darken, lighten, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

/**
 * Contains style information for the choices page.
 */
export const ChoicesPageStyles = makeStyles((theme: Theme) => ({
    root: {},
    introductionHeader: {
        padding: "20px",
        background: "#3C3C3B",
        borderBottom: "solid 1px #449B23",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "22px !important",
        "& > div": {
            width: "100%",
        },
    },

    introductionTitle: {
        fontSize: "21px",
        lineHeight: "25px",
        letterSpacing: "-0.53px",
        color: "#FFFFFF",
        opacity: 1,
        fontWeight: "bold",
        marginBottom: "7px",
    },
    introductionSubTitle: {
        fontSize: "14px",
        lineHeight: "18px",
        color: "#fff",
        fontWeight: "normal",
        letterSpacing: "-0.21px",
    },
    choicesAreas: {
        margin: "0 18px",
        padding: "8px 0",

        "& > div": {
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "15px",
        },
    },
    choicesArea: {
        background: "#FFFFFF",
        boxShadow: "0px 2px 6px #00000029",
        borderRadius: "3px",

        "& > button": {
            display: "flex",
            alignItems: "center",

            "& > div.MuiCardMedia-root": {
                minHeight: "90px",
                width: "100%",
                maxWidth: "50%",
                objectFit: "cover",
            },
            "& > div.MuiCardContent-root": {
                padding: "10px",
                textAlign: "center",
                width: "100%",
                maxWidth: "50%",
            },
        },
    },
    choicesAreaTitle: {
        fontSize: "14px",
        color: "#191919",
        fontWeight: "bold",
        lineHeight: "18px",
        letterSpacing: "-0.21px",
        marginBottom: "4px",
    },
    choicesAreaSubTitle: {
        fontSize: "12px",

        color: "#191919",
        fontWeight: "normal",
        lineHeight: "normal",
        letterSpacing: "-0.18px",
    },
    choicesAreasSummaryContainer: {
        padding: "0 0 16px 0",
    },
    choicesAreasSummaryTitle: {
        fontSize: "14px",
        fontWeight: "bold",
        lineHeight: "1.25",
        margin: "14px 0px",
    },
    choicesAreasSummary: {
        "& > div": {},
    },

    choicesAreaSummaryTitleContainer: {
        padding: "5px 15px",
        position: "relative",
        alignItems: "center",
        borderRadius: "3px 3px 0px 0px",
        backgroundColor: "#ECECEC",
        minHeight: "40px",
        display: "flex",
        justifyContent: "center",
        "& button": {
            width: "30px",
            height: "30px",
            background: "#449B23",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px",
            position: "absolute",
            right: "15px",
            top: "5px",
            color: "#fff",
        },
    },
    choicesAreaSummaryTitle: {
        color: "#191919",
        fontSize: "14px",
        fontWeight: "bold",
        lineHeight: "18px",
        letterSpacing: "-0.53px",
        textAlign: "center",
    },
    choicesAreaSummarySubTitle: {
        fontSize: "12px",
        lineHeight: "14px",
        color: "#191919",
        fontWeight: 700,
        letterSpacing: "-0.3px",
        marginBottom: "14px",
    },
    choicesAreaSummaryOptionsContainer: {
        fontSize: "12px",
    },
    choicesAreaSummaryExtrasContainer: {
        padding: "12px 15px",
        borderTop: "1px #707070 dashed",
    },
    editIcon: {},
    productSummaryContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "8px",
        gap: "20px",
        "& > div:": {
            fontSize: "12px",
            lineHeight: "14px",
            color: "#191919",
            fontWeight: 400,
            letterSpacing: "-0.3px",
        },
        "& > div:last-child": {
            minWidth: "60px",
            textAlign: "end",
        },
    },

    choicesAreasSummarySubTotal: {
        display: "flex",
        fontSize: "12px",
        "& > div:first-child": {
            fontWeight: "bold",
            marginRight: "12px",
        },
    },
    smallText: {
        width: "calc(100% - 170px)",
    },
    choicesAreasSummarySubtitle: {
        gap: "10px 30px",
        display: "flex",
        background: "#449b23",
        color: "#fff",
        padding: "5px 12px",
        borderRadius: "3px",
    },
    choicesAreasMainHeadingBlock: {
        display: "flex",
        alignItems: "center",
        padding: "20px",
        gap: "80px",
        background: "#3C3C3B",
        margin: "20px 0 30px 0",
        borderBottom: "solid 1px #449B23",
        justifyContent: "space-between",
    },
    choicesAreasMainSummaryTitle: {
        fontSize: "21px",
        lineHeight: "25px",
        color: "#fff",
        fontWeight: 700,
        letterSpacing: "-0.53px",
    },
    choicesSummaryCardRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: "15px",
        "& > .MuiCard-root": {
            padding: "0px",
            boxShadow: "none",
            border: "solid 1px #ECECEC",
            "& > .MuiCardContent-root": {
                padding: "0px",
            },
        },
    },
    choicesAreaSummaryContent: {
        padding: "12px 15px",
        background: "#FFFFFF",
    },
    [theme.breakpoints.up("md")]: {
        introduction: {
            margin: "28px 18px 15px 18px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flex: "0 0 auto", // Fix for MacBook Safari - Catalina
            "& > button": {
                padding: "0",
            },
            "& .MuiSvgIcon-root": {
                margin: "-7px",
                fontSize: "35px",
            },
        },

        choicesAreas: {
            borderTop: "none",
            marginTop: "-3px",
            paddingTop: "0px",
            "& > div": {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill,minmax(302px, 1fr))",
            },
        },

        choicesAreasSummaryTitle: {
            fontSize: "16px",
            marginTop: "27px",
        },

        choicesAreaSummaryOptionsContainer: {
            padding: "0px 0 4px 0",
        },
    },
    [theme.breakpoints.down("md")]: {
        choicesSummaryCardRow: {
            gap: "10px",
            gridTemplateColumns: "1fr 1fr 1fr",
        },
    },
    [theme.breakpoints.down("sm")]: {
        choicesSummaryCardRow: {
            gridTemplateColumns: "1fr  1fr",
        },
        choicesAreas: {
            margin: "0 30px",
            "& > div": {
                gridTemplateColumns: "1fr 1fr",
            },
        },
        introductionHeader: {
            padding: "16px 20px",
            "& > div": {
                textAlign: "center",
            },
        },
        introductionSubTitle: {
            fontSize: "10px",
            lineHeight: "15px",
        },
        choicesAreasSummary: {
            padding: "0 30px",
        },
        choicesAreasMainHeadingBlock: {
            flexDirection: "column",
            padding: "16px 20px",
            gap: "10px",
        },
    },
    [theme.breakpoints.down("xs")]: {
        choicesAreas: {
            "& > div": {
                gridTemplateColumns: "1fr ",
            },
        },
        choicesAreasSummarySubtitle: {
            gap: "5px 30px",
            flexDirection: "column",
            justifyContent: "space-between",
        },
        choicesAreasSummarySubTotal: {
            justifyContent: "space-between",
        },
        choicesSummaryCardRow: {
            gridTemplateColumns: "1fr ",
        },
    },
}));
